import { useIntl } from 'react-intl';
import { Route, Routes } from 'react-router-dom';

import { navigateToMyFiles } from 'router/navigation';

import { DocumentTitle, ErrorView, IntlErrorBoundary, Sidebar } from '_common/components';

import SharedListPage from './pages/SharedListPage/SharedListPage';

import styles from './SharedContainer.module.scss';

const SharedContainer = () => {
  const intl = useIntl();

  return (
    <div className={styles.root}>
      <Sidebar />
      <Routes>
        <Route
          index
          element={
            <DocumentTitle
              title={`doDOC - ${intl.formatMessage({
                id: 'storage.sidebar.shared',
              })}`}
            >
              <IntlErrorBoundary size="xl" style={{ margin: '21rem auto 0 auto' }}>
                <SharedListPage />
              </IntlErrorBoundary>
            </DocumentTitle>
          }
        />
        <Route
          path="*"
          element={
            <ErrorView
              onClick={navigateToMyFiles}
              error={{
                status: 404,
              }}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default SharedContainer;
